module.exports = __webpack_public_path__ + "img/spartan-tenant-improvements-02-tablet.7fca86ed.jpg";